// Mantine
import { Modal, Switch } from '@mantine/core'

// React
import { useEffect, useRef, useState } from 'react'

// QR Code Scanner
import QrScanner from 'qr-scanner'

import QRCodeScanner from './QRCodeScanner'

import { ErrorBoundary } from 'react-error-boundary'

export function CameraScannerTemp({ onClose, opened, onScan }) {
    const onScanHandler = (string) => {
        if (string) {
            console.log('scanned', string)

            const recognized = onScan(string)
            if (recognized !== false) {
                onClose()
            }
        }
    }

    return (
        <Modal
            keepMounted={true}
            size={1000}
            opened={opened}
            onClose={onClose}
            withCloseButton={false}
        >
            <ErrorBoundary fallback={<div>Une erreur est survenue</div>}>
                {opened && (
                    <QRCodeScanner
                        onScanSuccess={onScanHandler}
                        onScanFailure={() => {}}
                    />
                )}
            </ErrorBoundary>
        </Modal>
    )
}

export default function CameraScanneOld({ onClose, opened, onScan }) {
    const videoRef = useRef()

    const [scanner, setScanner] = useState(null)
    const [keepCameraOpened, setKeepCameraOpened] = useState(false)

    const onScanHandler = (string) => {
        if (string) {
            console.log('scanned', string)
            const recognized = onScan(string)
            if (recognized !== false && !keepCameraOpened) {
                onClose()
            }
        }
    }

    useEffect(() => {
        if (opened) {
            // If scanner already exists, start it
            if (scanner) {
                scanner.start()
                scanner.setInversionMode('both')
            } else {
                // If scanner doesn't exist, create it
                const newScanner = new QrScanner(
                    videoRef.current,
                    (result) => {
                        onScanHandler(result.data)
                    },
                    { highlightScanRegion: true, onDecodeError: () => {} }
                )

                newScanner.start()
                newScanner.setInversionMode('both')

                setScanner(newScanner)
            }
        } else {
            // If scanner exists, stop it
            if (scanner) {
                scanner.stop()
            }
        }
    }, [opened, keepCameraOpened])

    return (
        <>
            <Modal
                keepMounted={true}
                size={1000}
                opened={opened}
                onClose={onClose}
                withCloseButton={false}
            >
                <video ref={videoRef} className="bg-gray-200 w-full" />

                <div className="hidden">
                    <Switch
                        label="Garder la caméra ouverte"
                        checked={keepCameraOpened}
                        onChange={(e) =>
                            setKeepCameraOpened(e.currentTarget.checked)
                        }
                    />
                </div>
            </Modal>
        </>
    )
}
